import Vue from 'vue'
Vue.component('my-table', () => import('./table.vue'))
Vue.component('my-table2', () => import('./table2.vue'))
Vue.component('my-search', () => import('./search.vue'))
Vue.component('my-details', () => import('./details.vue'))
Vue.component('my-upload', () => import('./upload.vue'))
